import { render, staticRenderFns } from "./Bimini_cocktailItem.vue?vue&type=template&id=69a28462&scoped=true"
import script from "./Bimini_cocktailItem.vue?vue&type=script&lang=ts"
export * from "./Bimini_cocktailItem.vue?vue&type=script&lang=ts"
import style0 from "./Bimini_cocktailItem.vue?vue&type=style&index=0&id=69a28462&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a28462",
  null
  
)

export default component.exports